<template>
    <div class="wrapper">
        <div role="main" class="main">
            <div class="login-text">
                Please log in <a v-if="walletApiUrl" :href="walletApiUrl">here</a>
            </div>
            <hr />
        </div>
    </div>
</template>

<script>
export default {
    name: 'CasinoLoginRestriction',
    props: {
        walletApiUrl: {
            type: String,
            default: null
        },
    },
};
</script>

<style scoped>
.wrapper {
    text-align: center;
    margin: 0 auto 5em auto;
}

.main {
    overflow: hidden;
    margin-top: 5em;
    background-color: #252f3f;
    font-family: Nunito, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 10pt;
    color: #fff;
    line-height: 25px;
}

.login-text {
    display: block;
    font-size: 2em;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
}

a {
    color: #3490dc;
}
</style>
